module.exports = __webpack_public_path__ + "static/img/kapeizhi.392c7f4e.png";